import React, { ReactElement } from "react";
import styles from "./styles.module.scss"
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useAppSelector } from "redux/hooks";
import { RevenueDetails } from "redux/wallet/walletSlice";
import { Translate } from "react-redux-i18n";

export default function RevenueDetail(): ReactElement {
  const revenueDetail = useAppSelector(state => state.wallet.revenueDetails)
  const divider = useAppSelector(state => state.wallet.revenues?.currency.divider)
  const decimal = useAppSelector(state => state.wallet.revenues?.currency.decimal)
  const symbol = useAppSelector(state => state.wallet.revenues?.currency.symbol)
  return (
    <TableContainer className={styles.revenueDetailContainer}>
      <Table className={styles.table}>
        <TableHead>
          <TableRow className={styles.headerRow}>
            <TableCell className={styles.headerCell}>
              <Typography className={styles.headerLabel}>
                <Translate value="revenue.provider" />
              </Typography>
            </TableCell>
            <TableCell className={styles.headerCell}>
              <Typography className={styles.headerLabel}>
                <Translate value="revenue.bet" />.
              </Typography>
            </TableCell>
            <TableCell className={styles.headerCell}>
              <Typography className={styles.headerLabel}>
                <Translate value="revenue.win" />
              </Typography>
            </TableCell>
            <TableCell className={styles.headerCell}>
              <Typography className={styles.headerLabel}>
                <Translate value="revenue.profit" />
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {revenueDetail?.map((detail: RevenueDetails, index: number) =>
            <TableRow key={index} className={styles.row}>
              <TableCell className={styles.tableCell}>{detail.provider.name}</TableCell>
              <TableCell className={styles.tableCell}>{divider && (detail.play / divider).toFixed(decimal)} {symbol}</TableCell>
              <TableCell className={styles.tableCell}>{divider && (detail.win / divider).toFixed(decimal)} {symbol}</TableCell>
              <TableCell className={`${styles.tableCell} 
              ${detail.profit < 0 ?
                  styles.negative :
                  detail.profit > 0 ? styles.positive : ""}`}>
                {divider && (detail.profit / divider).toFixed(decimal)} {symbol}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  )
}